import React, { useState } from 'react';
import { url } from '../../util/config';

const GroupOptions = ({
    groupOption,
    setGroupOption,
    groupName,
    setGroupName,
    existingGroups,
    setSelectedGroup,
    selectedGroup,
    fetchExistingGroups,
    errorMessageInput,
}) => {
    const [nameAvailabilityMessage, setNameAvailabilityMessage] = useState('');
    const [isChecking, setIsChecking] = useState(false);

    const checkGroupNameAvailability = async (name) => {
        if (name.length < 4) { setNameAvailabilityMessage(''); return; }
        setIsChecking(true);
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${url}/contacts/checkGroupName`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
                body: JSON.stringify({ group_name: name }),
            });
            if (response.ok) {
                const data = await response.json();
                setNameAvailabilityMessage(data.available ? '✓ Group name is available.' : '✗ Group name is already taken.');
            } else {
                setNameAvailabilityMessage('');
            }
        } catch (error) {
            console.error('Error checking group name:', error);
            setNameAvailabilityMessage('');
        } finally {
            setIsChecking(false);
        }
    };

    const options = [
        { value: 'CreateNew', label: 'Create New Group' },
        { value: 'AddToExisting', label: 'Add to Existing Group' },
    ];

    return (
        <div style={styles.wrapper}>
            <label style={styles.label}>Group Options</label>
            <div style={styles.radioRow}>
                {options.map((opt) => (
                    <label key={opt.value} style={{ ...styles.option, ...(groupOption === opt.value ? styles.optionActive : {}) }}>
                        <input
                            type="radio"
                            name="groupOption"
                            value={opt.value}
                            checked={groupOption === opt.value}
                            onChange={(e) => {
                                setGroupOption(e.target.value);
                                if (e.target.value === 'AddToExisting') fetchExistingGroups();
                            }}
                            style={{ display: 'none' }}
                        />
                        <span style={{ ...styles.dot, ...(groupOption === opt.value ? styles.dotActive : {}) }}></span>
                        {opt.label}
                    </label>
                ))}
            </div>

            {groupOption === 'CreateNew' && (
                <div style={styles.inputWrapper}>
                    <input
                        type="text"
                        placeholder="Enter group name (4–20 characters)"
                        value={groupName}
                        maxLength="20"
                        style={styles.input}
                        onChange={(e) => {
                            setGroupName(e.target.value);
                            checkGroupNameAvailability(e.target.value);
                        }}
                    />
                    {isChecking && <span style={styles.checking}>Checking…</span>}
                    {!isChecking && nameAvailabilityMessage && (
                        <span style={{ ...styles.availMsg, color: nameAvailabilityMessage.startsWith('✓') ? '#16a34a' : '#dc2626' }}>
                            {nameAvailabilityMessage}
                        </span>
                    )}
                </div>
            )}

            {groupOption === 'AddToExisting' && (
                <select
                    style={styles.select}
                    value={selectedGroup}
                    onChange={(e) => setSelectedGroup(e.target.value)}
                >
                    <option value="">Select a group</option>
                    {existingGroups.map((group) => (
                        <option key={group._id} value={group._id}>{group.group_name}</option>
                    ))}
                </select>
            )}

            {errorMessageInput && <span style={styles.error}>{errorMessageInput}</span>}
        </div>
    );
};

const styles = {
    wrapper: { marginBottom: '20px', display: 'flex', flexDirection: 'column', gap: '10px' },
    label: { fontSize: '13px', fontWeight: '600', color: '#374151' },
    radioRow: { display: 'flex', gap: '10px', flexWrap: 'wrap' },
    option: { display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '8px 16px', border: '1.5px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', color: '#374151', fontWeight: '500', userSelect: 'none' },
    optionActive: { border: '1.5px solid #1565c0', background: '#eff6ff', color: '#1565c0' },
    dot: { width: '14px', height: '14px', borderRadius: '50%', border: '2px solid #d1d5db', flexShrink: 0 },
    dotActive: { border: '4px solid #1565c0', background: 'white' },
    inputWrapper: { display: 'flex', flexDirection: 'column', gap: '4px' },
    input: { padding: '10px 12px', fontSize: '14px', border: '1.5px solid #d1d5db', borderRadius: '8px', outline: 'none', width: '100%', boxSizing: 'border-box', color: '#111827' },
    select: { padding: '10px 12px', fontSize: '14px', border: '1.5px solid #d1d5db', borderRadius: '8px', outline: 'none', width: '100%', boxSizing: 'border-box', color: '#111827', background: 'white' },
    checking: { fontSize: '12px', color: '#9ca3af' },
    availMsg: { fontSize: '12px', fontWeight: '500' },
    error: { fontSize: '12px', color: '#ef4444' },
};

export default GroupOptions;
